import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";
import { ProgressHttp } from "angular-progress-http";

import { environment } from "../../../environments/environment";
import { HeaderService } from "./../http/header.service";
import { CandidatoService } from "./../candidato/candidato.service";
import { DocumentoGlobal } from "./documento-global";
import { PessoaService } from "../pessoa/pessoa.service";
import { ParametrosGeraisService } from "../parametros-gerais/parametros-gerais.service";
import { Subject } from "rxjs";

@Injectable()
export class DocumentoService {
  constructor(
    private ProgressHttp: ProgressHttp,
    private http: Http,
    private CandidatoService: CandidatoService,
    private HeaderService: HeaderService,
    private DocumentoGlobal: DocumentoGlobal,
    private PessoaService: PessoaService,
    private ParametrosGeraisService: ParametrosGeraisService
  ) {}

  uploadDocumentos(documentosCandidato): Observable<any> {
    var subject = new Subject<string>();

    if (this.CandidatoService.getChangeDocumentos() && documentosCandidato) {
      const documentos: Array<any> = [];

      documentosCandidato.forEach((documento) => {
        documento.DocCaminho.forEach((caminho) => {
          if (caminho.caminhoDocItem !== "") {
            if (this.validaCaminho(caminho.caminhoDocItem)) {
              documentos.push(
                this.setDocumentoGlobal(
                  documento,
                  caminho,
                  this.getData(caminho)
                )
              );
            }
          } else {
            documentos.push(this.setDocumentoGlobal(documento, caminho, ""));
          }
        });
      });

      if (documentos.length >= 1) {
        this.uploadDocumentosCandidato(documentos).subscribe(
          (response) => subject.next(response),
          (err) => {
            return subject.error(err);
          }
        );
      }
    } else {
      subject.complete(); 
    }

    return subject.asObservable();
  }

  setDocumentoGlobal(documento, caminho, blob) {
    const documentoGlobal = {
      TipDocCod: documento.TipDocCod,
      TipDocVerso: this.getVerso(documento),
      TipDocVarios: this.getVarios(documento),
      ArquivoBlobString: blob,
      ExtensaoArq: this.getExtensao(caminho),
      PrcTipEnt: caminho.PrcTipEnt,
    };

    return documentoGlobal;
  }

  getVerso(documento) {
    return documento.TipDocFlgVerso ? "S" : "N";
  }

  getVarios(documento) {
    return documento.TipDocFlgVarios ? "S" : "N";
  }

  getData(caminho) {
    return caminho.caminhoDocItem.split(",").pop();
  }

  getExtensao(caminho) {
    if (caminho.ExtensaoArq) {
      return caminho.ExtensaoArq;
    }
    return caminho.caminhoDocItem.split(".").pop();
  }

  uploadDocumentosCandidato(documentos): Observable<any> {
    const documentosWs = this.trataDocumentosComVerso(documentos);

    if (documentosWs.length >= 1) {
      this.CandidatoService.setChangeDocumentos(false);

      return this.http
        .post(
          environment.apiGxUrl + "/wsprcdocumentos.svc/rest/",
          {
            SdtDocumento: documentosWs,
          },
          { headers: this.HeaderService.getHeadersGnx() }
        )
        .map((res) => res.json())
        .catch((err: any) => Observable.throw(err));
    }
  }

  trataDocumentosComVerso(documentos) {
    documentos.forEach((documento, index) => {
      if ((documento.TipDocVarios = "N")) {
        if (
          documento.TipDocVerso == "S" &&
          index == 1 &&
          documentos.length == 2
        ) {
          documento.TipDocVerso = "S";
        } else {
          documento.TipDocVerso = "N";
        }
      }

      if (documentos.length >= 2 && index >= 1) {
        documento.TipDocVarios = "S";
      }
    });
    return documentos;
  }

  validaCaminho(caminho) {
    const regex =
      /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    return !regex.test(caminho);
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/documento/documento.service.ts